import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';

@Component({
  selector: 'app-drop-down',
  templateUrl: './drop-down.component.html',
  styleUrls: ['./drop-down.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class DropDownComponent {
  @Input() list: any = [];
  @Input() settings: any = [];
  @Input() type: string = '';
  @Output() dropDownChanged: EventEmitter<any> = new EventEmitter<any>();
  @Input() selectedItems: any = [];

  onItemSelect(item: any) {
    this.dropDownChanged.emit({
      item: item,
      type: this.type,
      action: 'selected',
    });
  }
  onItemDeSelect(item: any) {
    this.dropDownChanged.emit({
      item: item,
      type: this.type,
      action: 'deSelected',
    });
  }
  onSelectAll(items: any) {
    console.log('onSelectAll', items);
    items.forEach((item: any) => {
      this.dropDownChanged.emit({
        item: item,
        type: this.type,
        action: 'selected',
      });
    });
  }
  onUnSelectAll() {
    console.log('onUnSelectAll fires');
    this.dropDownChanged.emit({
      item: '',
      type: this.type,
      action: 'deSelectedAll',
    });
  }

  clearAllSelection() {
    this.selectedItems = [];
    this.onUnSelectAll();
  }
}
